{
  "errors": {
    "failedToLoadInventoryLedger": "Échec du chargement du registre d'inventaire"
  },
  "pages": {
    "inventoryLedger": "Registre d'inventaire",
    "immutableMovementLogSourceOfTruth": "Journal des mouvements immuable — source de vérité pour tous les changements de quantité"
  },
  "labels": {}
}
